import { useState } from 'react';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { View } from 'foundations-components/transitional/components/View';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Select } from 'foundations-components/transitional/components/Select';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { FloatingAlertList, FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { useLoginVerifyQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/AccessRpc.hooks';
import { useUpdatePreferredLanguageMutation } from '../../__generated__/chirp/com/hubspot/portals/platform/reference/be/rpc/PortalRpc.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANGUAGE_CODES = ['da', 'nl', 'en', 'fi', 'fr', 'de', 'it', 'ja', 'ko', 'no', 'pl', 'pt-br', 'zh-cn', 'es', 'sv', 'th', 'zh-tw'];
function getBrowserLanguage() {
  const browserLang = navigator.language.toLowerCase();
  if (LANGUAGE_CODES.includes(browserLang)) {
    return browserLang;
  }
  const baseLang = browserLang.split('-')[0];
  if (LANGUAGE_CODES.includes(baseLang)) {
    return baseLang;
  }
  return 'en';
}
export function Settings() {
  var _ref;
  const {
    data: loginData,
    loading: loginLoading
  } = useLoginVerifyQuery();
  const [updatePreferredLanguage, {
    loading: updateLoading
  }] = useUpdatePreferredLanguageMutation({
    onCompleted: () => {
      FloatingAlertStore.addAlert({
        message: I18n.text('app.settings.successMessage'),
        titleText: I18n.text('app.settings.successTitle'),
        type: 'success'
      });
    },
    onError: () => {
      FloatingAlertStore.addAlert({
        message: I18n.text('app.settings.errorMessage'),
        titleText: I18n.text('app.settings.errorTitle'),
        type: 'danger'
      });
    }
  });
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const currentLanguage = (_ref = selectedLanguage !== null && selectedLanguage !== void 0 ? selectedLanguage : loginData === null || loginData === void 0 ? void 0 : loginData.preferredLanguage) !== null && _ref !== void 0 ? _ref : getBrowserLanguage();
  const languageOptions = LANGUAGE_CODES.map(code => ({
    text: I18n.text(`app.settings.languages.${code}`),
    value: code
  }));
  const handleLanguageChange = evt => {
    setSelectedLanguage(evt.target.value);
  };
  const handleSubmit = evt => {
    evt.preventDefault();
    updatePreferredLanguage({
      variables: {
        language: currentLanguage
      }
    }).catch(err => console.error(err));
  };
  if (loginLoading) {
    return /*#__PURE__*/_jsx(View, {
      padding: "600",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {})
    });
  }
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "SETTINGS_LOAD",
    children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsxs(View, {
      padding: "600",
      maxInlineSize: "600px",
      children: [/*#__PURE__*/_jsx(H4, {
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.settings.title"
        })
      }), /*#__PURE__*/_jsxs("form", {
        onSubmit: handleSubmit,
        children: [/*#__PURE__*/_jsx(View, {
          marginBlockEnd: "400",
          children: /*#__PURE__*/_jsx(FormControl, {
            label: I18n.text('app.settings.preferredLanguageLabel'),
            children: /*#__PURE__*/_jsx(Select, {
              value: currentLanguage,
              onChange: handleLanguageChange,
              options: languageOptions
            })
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "submit",
          use: "primary",
          disabled: updateLoading,
          children: updateLoading ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.settings.saving"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.settings.save"
          })
        })]
      })]
    })]
  });
}